// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

// Every headline face a skin may name, keyed by the family name the skin uses. Metro needs
// static require() calls, so this table is the one place a new skin's font gets added.
const BRAND_FONT_FILES: Record<string, number> = {
  Sanchez: require('../assets/fonts/Sanchez-Regular.ttf'),
  Sora: require('../assets/fonts/Sora-SemiBold.ttf'),
  Fraunces: require('../assets/fonts/Fraunces-SemiBold.ttf'),
  Archivo: require('../assets/fonts/Archivo-ExtraBold.ttf'),
};

/**
 * The font files the active skin needs, for useFonts() in the root layout. Only the active
 * skin's headline face is loaded: bundling all of them costs nothing at runtime, loading them
 * all at startup would.
 */
export function activeSkinFontFiles(): Record<string, number> {
  const brand = activeSkin.fonts.brand;
  const file = BRAND_FONT_FILES[brand];
  if (!file) {
    console.warn(`Skin font "${brand}" has no bundled file in theme/fonts.ts; the platform default will show.`);
    return {};
  }
  return { [brand]: file };
}
